import { api } from "api";
import { configureStore } from "@reduxjs/toolkit";
import errorReducer from "features/error/error";
import { rtkQueryErrorLogger } from "features/error/errorLogger";

const middlewares = [api.middleware, rtkQueryErrorLogger];

const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    error: errorReducer.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat(middlewares),
});

export default store;
